export function Header() {
  // スクロール量でヘッダーにclass付与

  $(window).on('load resize', function () {
    const header = $('.Header');
    const headerH = header.height() + 50;
    let scrollY = $(window).scrollTop();

    if(scrollY > headerH) {
      header.addClass('-mini');
    } else {
      header.removeClass('-mini');
    }

    $(window).scroll(function () {
      if($(window).scrollTop() > headerH) {
        header.addClass('-mini');
      } else {
        header.removeClass('-mini');
      }
    });
  });
}